import { GenericCatalog } from '@mode-switch/adapt';
export class FlamingoCatalog extends GenericCatalog {
}
